import logging from './logging';

/**
 * @param {string} event
 * @param {Record<string,*>|undefined} data
 *
 * @returns {void}
 */
export default function gtmDataLayerPush(event, data = {}) {
	if (!event) {
		throw new Error('Event is required');
	}

	if (typeof event !== 'string') {
		throw new Error('Event must be a string');
	}

	let _data = {};

	if (data) {
		const d = JSON.stringify(data);

		_data = JSON.parse(d);
	}

	logging('GTM DataLayer Push', () => {
		console.log('Event:', event);
		console.log('Data:', _data);
	});

	window.dataLayer?.push({
		event,
		..._data,
	});
}
